import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG = "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg";

export default function About() {
  return (
    <div>
      <section className="bg-[#06152D] text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[#8AB4FF]">About Us</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tight">
            Loan Junction Finance Services
          </h1>
          <p className="mt-5 text-lg text-[#B5C4E1] max-w-2xl leading-relaxed">
            A technology-enabled loan and insurance sourcing partner proudly serving customers
            across Telangana — since day one, our mission has been simple:
            <em className="text-white"> make loans transparent, human, and fast.</em>
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <img src={ABOUT_IMG} alt="Team" className="rounded-2xl shadow-lg w-full object-cover aspect-[4/3]" />
          <div>
            <h2 className="font-display text-3xl font-bold tracking-tight text-[#06152D]">Our story</h2>
            <p className="mt-4 text-[#52525B] leading-relaxed">
              Loan Junction was founded to solve a simple problem — most families and small
              businesses in Telangana don't know the difference between the twenty-odd banks
              and NBFCs offering loans. Rates change monthly. Terms are opaque. Paperwork is
              overwhelming.
            </p>
            <p className="mt-4 text-[#52525B] leading-relaxed">
              We built a single, transparent junction: you tell us what you need, we do the
              legwork with our banking partners, and you sign only what you understand.
            </p>
            <div className="mt-6 space-y-3">
              {[
                "Partnered with 20+ leading banks & NBFCs across India",
                "Multi-lingual advisors (Telugu / Hindi / English)",
                "In-house CRM tracks every file end-to-end",
                "Insurance & post-disbursal support included",
              ].map((v) => (
                <div key={v} className="flex gap-2 items-start">
                  <CheckCircle2 size={18} className="text-[#059669] mt-0.5 shrink-0" />
                  <span className="text-[#09090b]">{v}</span>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <Link to="/contact" className="bg-[#0052FF] hover:bg-[#003FCC] text-white font-semibold px-6 py-3 rounded-full inline-block" data-testid="about-contact-cta">
                Get in touch
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
